import React, {Component} from 'react';
import WOW from "wowjs";
import "../../assets/css/videoScore.css";
import "../../assets/js/countTo.js";
import FeedbackContainer from '../../containers/Video/FeedbackContainer';

/* global $ */

class VideoScore extends Component {
    constructor(props){
        super(props);

        this.state = {
            positivePoints: 0,
            negativePoints: 0,
            count: 0,
            show: true,
            wow: null,
            wowInitted: false,
            sentFeedback: false,
            showFeedbackModal: false
        }
    }
    
    calculateTotal = () => {
        var balance = $(".meritsBalance h3").text();
        balance = Number(balance)+Number(this.state.positivePoints)-Number(this.state.negativePoints);
        if(!isNaN(balance)){
            $(".meritsBalance h3").html(balance);
            
            $(".meritsBalance h3").countTo({
                speed: 2000,
                to: isNaN(balance) ? 0 : balance,
                from: isNaN(this.props.totalPoints) ? 0 : this.props.totalPoints
            });
        }
    }
    
    componentDidUpdate(props, state){
        
        if(this.state.wowInitted === false){
            this.setState({wowInitted: true}, () => {
                this.state.wow.init();
                let self = this;
                setTimeout(function(){
                    self.renderAnimation();
                }, 1000);
                
                setTimeout(function(){
                    $(".dangerLevel").addClass("breathable");
                    var meritsEarned = $(".meritsEarned").data("merits-earned");
                    var meritsLost = $(".meritsLost").data("merits-lost");
                    for(let x=1; x<=meritsEarned; x++)
                    {
                        
                        //$(".meritsEarned").append("<span class='meritPointEr wow bounceInDown' data-wow-delay='"+d+"s'>+1</span>");
                    }
                    for(let x=1; x<=meritsLost; x++)
                    {
                        
                        //$(".meritsLost").append("<span class='meritPointEr wow fadeInUp' data-wow-delay='"+d+"s'>-1</span>");
                    }
                },2000);
            })
        }else{
        
            if(props !== this.props){
                try{
                    this.state.wow.sync();
        
                }catch(err){
                }
            }
            
            if(this.state.count < 5 && state.count !== this.state.count && this.state.wow){
                this.renderAnimation();
            }else if(this.state.count === 5 && this.state.count !== state.count){
                this.calculateTotal();
            }
        }
    }
    
    renderAnimation = () => {
        
        try{
            this.state.wow.sync();
    
        }catch(err){
        }
         let point = [
            this.props.efficiencyPoints,
            this.props.attentivenessPoints,
            this.props.quizPoints,
            this.props.completionPoints
        ]
        let {positivePoints, negativePoints} = this.state;
        let self = this;

        let x = this.state.count;
        setTimeout(function(){
            var t = $(".LectureDetailsResultItem:eq("+x+")");
            var r = t.find(".LectureDetailsResultItemPercentage").attr("data-res");
            for(let y=0; y<r; y++)
            {
                var del = Math.ceil(y/1000);
                t.find(".LectureDetailsResultItemWrap").append("<span class='animated LectureScoreBar bounceInLeft' style='bottom:"+(y*10)+"%; animation-delay='" + del + "s'></span>")   
                self.state.wow.sync();
            }
            t.addClass("LectureDetailsResultItemActive");
            
            t.find(".LectureDetailsResultItemPercentage").css("height",(r*10)+"%");
            var CounterSpeed = 200;
            if(point[x] < 0 && x < 4){
                let points = point[x];
                let oldPoints = negativePoints;
                negativePoints -= points;

                $(".meritsLost h3").css("color","#F5A623")
                $(".meritsLost h3").countTo({
                    speed:CounterSpeed,
                    from: isNaN(oldPoints) ? 0 : oldPoints,
                    to: isNaN(negativePoints) ? 0 : negativePoints
                });
                
            }else if(x < 4){
                let points = point[x];
                let oldPoints = positivePoints;
                positivePoints += points;

                CounterSpeed = 400;
                $(".meritsEarned h3").css("color","#F5A623")
                $(".meritsEarned h3").countTo({
                    speed:CounterSpeed,
                    from: isNaN(oldPoints) ? 0 : oldPoints,
                    to: isNaN(positivePoints) ? 0 : positivePoints
                });
                
            }

            self.setState({count: self.state.count + 1, positivePoints, negativePoints});
        },400);


        
    }
    
    componentDidMount() {
        this.setState({wow: new WOW.WOW()});
      }
    
    playAudio = () => {
       var audio = document.getElementById("audio");
       audio.play();
       setTimeout(function(){
        audio.stop();
       },600);
    }
    
    render(){
        let {efficiency, efficiencyPoints, attentiveness, attentivenessPoints, quiz, quizPoints, completion, completionPoints, totalPoints} = this.props;
        return (
            <div>
            <div style={{position: 'fixed', height: '100vh', width: "100%", zIndex: 999, pointerEvents: 'none'}} className="videoScoreContainer">
            {!this.state.show &&
                    <button className="btn btn-primary showScore" onClick={e => this.setState({show: true})}>Show Score <i className="zmdi zmdi-chevron-up" /></button>
                }
            <div className={`videoCompletedOverlay ${this.state.show ? 'animated fadeIn' : 'animated fadeOut'}`}>
                
                <div className="container">
                    <div className="row">
                        <div className="col-sm-12">
                            <div className="pull-right">
                                <button className="btn btn-transparent" onClick={() => this.setState({show: false})}><i className="zmdi zmdi-close" /></button>
                            </div>
                            <h1>{this.props.finishedSubject ? 'Subject' : 'Lecture'} Complete</h1>
                        </div>
                        <div className="col-sm-12">
                            <div className="LectureDetailsResultsWrap">
            
 
            
                                <div className={`LectureDetailsResultItem ${efficiencyPoints < 0 ? 'dangerLevel' : ''}`}>
                                    <div className={`meritPoints ${efficiencyPoints < 0 ? 'meritPointsLost' : ''} wow bounceIn`} data-wow-delay='1.5s'>{efficiencyPoints}<span>Merits</span></div>
            
            
                                    <div className="LectureDetailsResultItemWrap">
                                        <div className="LectureDetailsResultItemSummary">
                                            <h2 className="animated bounceInUp" style={{animationDelay: '1.5s'}} data-wow-delay='1.5s'><small>Efficiency</small></h2>
                                            <p className="animated bounceInRight" style={{animationDelay: '1.5s'}} data-wow-delay='1.5s'>{efficiency}%</p>
                                        </div>
                                        <div className="LectureDetailsResultItemPercentage" data-res={Math.ceil(efficiency / 10)}></div>
                                    </div>
                                </div>
            
                                <div className={`LectureDetailsResultItem ${attentivenessPoints < 0 ? 'dangerLevel' : ''}`}>
                                    <div className={`meritPoints ${attentivenessPoints < 0 ? 'meritPointsLost' : ''} wow bounceIn`} data-wow-delay='2s'>{attentivenessPoints}<span>Merits</span></div>
            
            
                                    <div className="LectureDetailsResultItemWrap">
                                        <div className="LectureDetailsResultItemSummary">
                                            <h2 className="animated bounceInUp" style={{animationDelay: '2s'}} data-wow-delay='2s'><small>Attentiveness</small></h2>
                                            <p className="animated bounceInRight" style={{animationDelay: '2s'}} data-wow-delay='2s'>{attentiveness}%</p>
                                        </div>
                                        <div className="LectureDetailsResultItemPercentage" data-res={Math.ceil(attentiveness / 10)}></div>
                                    </div>
                                </div>
            
                                <div className={`LectureDetailsResultItem ${quizPoints < 0 ? 'dangerLevel' : ''}`}>
                                    <div className={`meritPoints ${quizPoints < 0 ? 'meritPointsLost' : ''} wow bounceIn`} style={{animationDelay: '2.5s'}} data-wow-delay='2.5s'>{quizPoints}<span>Merits</span></div>
            
            
                                    <div className="LectureDetailsResultItemWrap">
                                        <div className="LectureDetailsResultItemSummary">
                                            <h2 className="animated bounceInUp" style={{animationDelay: '2.5s'}} data-wow-delay='2.5s'><small>Quiz Average</small></h2>
                                            <p className="animated bounceInRight" style={{animationDelay: '2.5s'}} data-wow-delay='2.5s'>{quiz > -1 ? quiz.toString() + '%' : 'NA'}</p>
                                        </div>
                                        <div className="LectureDetailsResultItemPercentage" data-res={Math.ceil(quiz / 10)}></div>
                                    </div>
                                </div>
            
                                <div className={`LectureDetailsResultItem ${completionPoints < 0 ? 'dangerLevel' : ''}`}>
                                    <div className={`meritPoints ${completionPoints < 0 ? 'meritPointsLost' : ''} wow bounceIn`} style={{animationDelay: '3s'}} data-wow-delay='3s'>{completionPoints}<span>Merits</span></div>
            
            
                                    <div className="LectureDetailsResultItemWrap">
                                        <div className="LectureDetailsResultItemSummary">
                                            <h2 className="animated bounceInUp" style={{animationDelay: '3s'}} data-wow-delay='3s'><small>Completion</small></h2>
                                            <p className="animated bounceInRight" style={{animationDelay: '3s'}} data-wow-delay='3s'>{completion}%</p>
                                        </div>
                                        <div className="LectureDetailsResultItemPercentage" data-res={Math.ceil(completion / 10)}></div>
                                    </div>
                                </div>
                                <div className={`LectureDetailsResultItem NextButton`} onClick={e => this.props.onContinue(e)}>
                                    
                                    <div className="LectureDetailsResultItemWrap">
                                        <i className="zmdi zmdi-arrow-right" />
                                        <p className="next-video">{this.props.finishedSubject ? 'To Dashboard' : 'Next Lecture'}</p>
                                    </div>
                                </div>                  
                            </div>
            
                            <div className="MeritsEearnedLost sp-top80">
                                <div className="row">
                                    <div className="col-sm-3">
                                        <div className="meritD meritsEarned" data-merits-earned='0'>
                                            <p>Merits Earned</p>
                                            <h3 className="meritscounter">0</h3>
                                        </div>
                                    </div>
                                    <div className="col-sm-3">
                                        <div className="meritD meritsLost" data-merits-lost='3'>
                                            <p>Merits Lost</p>
                                            <h3 className="meritscounter" data-to="80">0</h3>
                                        </div>
                                    </div>
            
                                    <div className="col-sm-2 col-sm-offset-4">
                                        <div className="meritD meritsBalance">
                                            <p>Total Merits</p>
                                            <h3 className="meritscounter">{totalPoints}</h3>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-12">
                            <div className="text-right">
                                {this.props.feedbackPrompt && !this.state.sentFeedback ?
                                    <button className="btn btn-primary" onClick={e => this.setState({showFeedbackModal: true})}>Leave Feedback</button>
                                : null}
                            </div>
                            
                            
                        </div>
                    </div>
                </div>
            </div>   
            </div>
            {this.state.showFeedbackModal &&
                <FeedbackContainer
                        courseId={this.props.courseUser.courseId}
                        profile={this.props.profile}
                        dismiss={() => this.setState({sentFeedback: true})}
                    />
            }
            </div>
        )
    }
}

export default VideoScore;


// WEBPACK FOOTER //
// ./src/components/Video/VideoScore.js